import { PayloadAction } from '@reduxjs/toolkit';

import { AddonsState, AttributionImage } from 'editor/src/store/editorModules/addons/types';

const setAddonsAttributionImageReducer = (state: AddonsState, action: PayloadAction<AttributionImage | undefined>) => {
  state.attributionImage = action.payload;
};

export default setAddonsAttributionImageReducer;
